import { type JSX, ReactElement, ReactNode } from "react";
import DocumentationLink from "@via/pages/data/components/documentation-link.tsx";

export default function DataSourceTitle({
  logoPath,
  icon,
  title,
  actions,
}: {
  logoPath?: string;
  icon?: ReactElement;
  title: string;
  actions?: ReactNode;
}): JSX.Element {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center">
        {logoPath ? (
          <img
            className="mr-3 h-10 w-10"
            alt={`${title} Logo`}
            src={logoPath}
          />
        ) : (
          icon
        )}
        <h2 className="via-h2 text-xl font-bold">{title}</h2>
      </div>

      <div className="flex items-center gap-4">
        <DocumentationLink />
        {actions}
      </div>
    </div>
  );
}
